import EquipmentListFastDirective from './equipment-list-fast.component';
import EquipmentListItem from './equipment-list-item.component';

//Details
import MapEquipmentDetailDirective from './details/equipment-detail.component';
import MapEquipmentDetailController from './details/equipment-detail.controller';


const equipmentListModule = angular.module('app.map.equipmentlist',[
	//THIRD PARTY
	'ui.router',
	'ui.bootstrap',
	'ui.router',
	'ncy-angular-breadcrumb',
	'gettext'
]);

equipmentListModule
	.controller('MapEquipmentDetailController', MapEquipmentDetailController)
	.directive('equipmentListFast',	EquipmentListFastDirective)
	.directive('equipmentListItem', EquipmentListItem)	
    .directive('mapEquipmentDetail', MapEquipmentDetailDirective)
    ;

export default equipmentListModule.name;